"use client"

import { useEffect, useState } from "react"
import { track } from "@/shared/lib/analytics"
import { getPostHogFeatureFlagClient } from "@/shared/lib/monitoring/telemetry-config"

const FLAG_KEY = "paywall-cta-loading-state"

interface PostHogWithFlags {
  getFeatureFlag: (key: string) => string | boolean | undefined
  onFeatureFlags: (cb: () => void) => () => void
}

let hasTrackedPaywallCtaLoadingExposure = false

function getPostHog(): PostHogWithFlags | null {
  return getPostHogFeatureFlagClient<PostHogWithFlags>()
}

export function usePaywallCtaLoadingState(): boolean {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    const ph = getPostHog()
    if (!ph) return

    const apply = () => {
      const variantValue = ph.getFeatureFlag(FLAG_KEY)
      if (variantValue !== undefined && !hasTrackedPaywallCtaLoadingExposure) {
        const isEnabled = variantValue === true
        hasTrackedPaywallCtaLoadingExposure = true
        setEnabled(isEnabled)
        track("sub:pricing_exposure", {
          flag: FLAG_KEY,
          variant: isEnabled ? "test" : "control",
        })
      } else if (variantValue !== undefined) {
        setEnabled(variantValue === true)
      }
    }

    apply()
    const unsubscribe = ph.onFeatureFlags(apply)
    return () => {
      unsubscribe()
    }
  }, [])

  return enabled
}
